export const orderByOverview = <T extends string>(
    items: readonly T[],
    overviewOrder: readonly string[] | undefined,
): T[] => {
    if (!overviewOrder?.length) {
        return [...items]
    }
    const rank = (item: T) => {
        const index = overviewOrder.indexOf(item)
        return index < 0 ? overviewOrder.length : index
    }
    return [...items].sort((a, b) => rank(a) - rank(b))
}
